module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 12
// module chunks = 0